// extracted by mini-css-extract-plugin
export default {"main":"locales_main__WwbSV","localize":"locales_localize__Ob8OI","ua":"locales_ua__91ipz","pl":"locales_pl__j8n3q","disable":"locales_disable__uM0gX"};